import SpringConfigs from '../swarm/spring-configs';

export const BETSLIP_STAKE_LIMIT = 9;
export const BETSLIP_STAKE_LIMIT_WITH_COMMA = BETSLIP_STAKE_LIMIT + 2;
export const SEPARATOR = SpringConfigs.PRICE_SEPARATOR === ',';
